import { createContext } from "react";
const SliderContext = createContext({
  debounceDelay: 2e3,
  disabled: false,
  errorMessage: "Please enter a valid value",
  formatter: () => "number",
  max: 100,
  min: 0,
  step: 0
});
export default SliderContext;
